/**
 * Created by Viacheslav on 18.09.2026
 */

const SeasonPassRewards = {
    findLogic: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_SEASON_PASS);
        return mission && mission.logic;
    },

    getIcon: function () {
        const logic = SeasonPassRewards.findLogic();
        return (logic && bundles.reward_icons.frames[`season_pass_reward_${logic.period}_png`]) || bundles.reward_icons.frames.season_pass_reward_png;
    },

    bundle: function () {
        const logic = SeasonPassRewards.findLogic();
        return logic ? [`season_pass_${logic.period}`] : [];
    },

    getTarget: function () {
        return `mission${Mission.TYPE_SEASON_PASS}`;
    }
};

Reward.register("seasonPassPoints", {
    bundle: SeasonPassRewards.bundle,
    getIcon: SeasonPassRewards.getIcon,
    getTarget: SeasonPassRewards.getTarget,

    parse: function (value, options) {
        const logic = SeasonPassRewards.findLogic();
        return logic && logic.canEarnPoints() ? [new Reward("seasonPassPoints", value, options)] : [];
    },

    receive: function (value) {
        const logic = SeasonPassRewards.findLogic();
        if (logic) {
            logic.awardPoints(value);
        }
    }
});

Reward.register("seasonPassVip", {
    bundle: SeasonPassRewards.bundle,
    getIcon: SeasonPassRewards.getIcon,
    getTarget: SeasonPassRewards.getTarget,

    getText: function () {
        return "VIP";
    },

    parse: function (value, options) {
        const logic = SeasonPassRewards.findLogic();
        if (!logic || logic.isVipUnlocked()) {
            return [];
        }
        return [new Reward("seasonPassVip", value, options)].concat(new RewardsList(logic.getVipPassRewards(), options).listRewards());
    },

    receive: function () {
        const logic = SeasonPassRewards.findLogic();
        if (logic) {
            logic.unlockVip();
        }
    }
});

Reward.register("seasonPassSuper", {
    bundle: SeasonPassRewards.bundle,
    getIcon: SeasonPassRewards.getIcon,
    getTarget: SeasonPassRewards.getTarget,

    getText: function () {
        return "Super";
    },

    parse: function (value, options) {
        const logic = SeasonPassRewards.findLogic();
        if (!logic || logic.isSuperUnlocked()) {
            return [];
        }
        const rewards = [new Reward("seasonPassSuper", value, options)];
        return logic.isVipUnlocked() ? rewards : rewards.concat(new RewardsList(logic.getVipPassRewards(), options).listRewards());
    },

    receive: function () {
        const logic = SeasonPassRewards.findLogic();
        if (logic) {
            logic.unlockVip();
            logic.unlockSuper();
            logic.awardPoints(SeasonPassLogic.SUPER_PASS_BONUS_POINTS);
        }
    }
});
